import { Component, Vue, Prop } from "vue-property-decorator";
import { isLogin } from "@/libs/auth";
import { _isMobile, isNotEmpty } from "@/libs/tools";
import { checkRight } from "@/api/course";

@Component
export default class Product extends Vue {
    @Prop() readonly item: any;
    @Prop() readonly itemTips: any;
    private currentProduct: any = {};
    private currentExpProduct: any = {};
    private btnExpContent: string = "加入学习";
    private btnContent: string = "加入学习";
    private currentProductId: any;
    private currentExpProductId: any;
    private isCurrentBuy: boolean = false;
    private isExpCurrentBuy: boolean = false;
    created(): void {
        this.currentProduct = this.item.currentProduct;
        this.currentExpProduct = this.item.currentExpProduct;
        this.currentProductId = this.currentProduct.productCourses[0].productId;
        if (isNotEmpty(this.currentExpProduct)) {
            this.currentExpProductId = this.currentExpProduct.productCourses[0].productId;
        }
        this.btnExpContent =
            this.currentExpProduct.buyStatus === "YES"
                ? "加入学习"
                : "敬请期待";
        this.btnContent =
            this.currentProduct.buyStatus === "YES" ? "加入学习" : "敬请期待";
        this.GetcheckRight();
    }
    GetcheckRight() {
        if (isLogin()) {
            if (isNotEmpty(this.currentProductId)) {
                checkRight(this.currentProductId).then(res => {
                    this.isCurrentBuy = res.data;
                    if (this.isCurrentBuy) {
                        this.btnExpContent = "已购买";
                    }
                });
            }
            if (isNotEmpty(this.currentExpProductId)) {
                checkRight(this.currentExpProductId).then(res => {
                    this.isExpCurrentBuy = res.data;
                });
            }
        }
    }
    handleBuyClick(productId) {
        if (!isLogin()) {
            this.$router.push("/login?status=" + "login");
        } else {
            this.$router.push({ path: "/order/" + productId });
        }
    }
    handleToStudyClick() {
        this.$router.push({ path: "/myRoom/course" });
    }
}
// @ts-ignore
export { default as Product } from "./index.vue";
